//import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import { Today } from '@mui/icons-material';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { Features } from '@src/core/features';
import { getNavBarBadgeRolesByAction } from '@src/roles';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '../authentication';
import { useProjectContext } from '../switch-project';
import { useInteractionContext } from './interaction.context';

type IconProps = {
  color: string;
  fontSize: number;
  total: number;
};

const Icon: FC<IconProps> = ({ color, fontSize, total }) => (
  <Badge badgeContent={total} color={'error'}>
    <Today
      sx={{
        color,
        fontSize,
      }}
    />
  </Badge>
);

type ContactTodayMenuProps = MenuItemStateProps & {
  variant: 'default' | 'mobile';
};

const ContactTodayMenu: FC<ContactTodayMenuProps> = ({ variant, isMini }) => {
  const { COLORS } = useTheme();
  const { allowAccess } = useSessionContext();
  const { allowedFeature } = useProjectContext();
  const { contactsTodayTotal } = useInteractionContext();
  const navigate = useNavigate();

  if (!allowAccess(getNavBarBadgeRolesByAction(Features.CONTACT_TODAY)) || !allowedFeature(Features.CONTACT_TODAY)) {
    return <></>;
  }

  const handleClick = () => {
    navigate('/interaction/contacts-today', { replace: true });
  };

  if (variant === 'mobile') {
    return (
      <Tooltip title={'Contatos para Hoje'}>
        <IconButton size={'large'} onClick={handleClick} sx={{ opacity: contactsTodayTotal > 0 ? 1 : 0.5 }}>
          <Icon color={COLORS.primary.contrast} fontSize={28} total={contactsTodayTotal} />,
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Contatos para Hoje',
        icon: (
          <Icon
            color={contactsTodayTotal > 0 ? COLORS.primary.main : COLORS.text.disabled}
            fontSize={24}
            total={contactsTodayTotal}
          />
        ),
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={handleClick}
    />
  );
};

export { ContactTodayMenu };
